import { render } from "./SupplierLocationEditMenu.vue?vue&type=template&id=2d6a94f2&scoped=true"
import script from "./SupplierLocationEditMenu.vue?vue&type=script&lang=js"
export * from "./SupplierLocationEditMenu.vue?vue&type=script&lang=js"

import "./SupplierLocationEditMenu.vue?vue&type=style&index=0&id=2d6a94f2&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6a94f2"]])

export default __exports__